import * as React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import logo from '../../assets/images/logo.png';
import Text from '../../components/text';


const ErrorPage: React.FC = () => {

  return (
    <div>
      <Container>
        <Row className="align-items-center">
          <Col md={2}>
            <img alt="Logo Desio" src={logo} className="logoDesio" />
          </Col>
          <Col md={10} >
            <Text title='Attenzione' type="titolo" />
            <Text title='Non sei autorizzato ad accedere' type="sottotitolo" />
            <Text title='Assicurati di aver avviato il processo di autenticazione in maniera corretta' type="testo" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ErrorPage;



